import { render, staticRenderFns } from "./SelectCommuneComponent.vue?vue&type=template&id=4795db4c"
import script from "./SelectCommuneComponent.vue?vue&type=script&lang=js"
export * from "./SelectCommuneComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports